<app-navbar></app-navbar>

<!-- Content -->
<div class="container-fluid" id="top">
    <div class="row py-lg-5">
        <div class="col-sm-6 offset-sm-3 project-content">
            <mdb-card>
                <!-- Project's informations -->

                <!-- Project image -->

                <!-- About the project -->
                <mdb-card-body>
                    <!-- Technologies used -->
                    <div class="row technos">
                        <div class="col-sm-6">
                            <div class="row">
                                <img src="moii.png" alt="">
                                <h4><b>Technologies : </b></h4>
                                <img class="dot" src="assets/skills/angular.png" />
                                <img class="dot" src="assets/skills/html.png" />
                                <img class="dot" src="assets/skills/css.png" />
                                <img class="dot" src="assets/skills/bootstrap.png" />
                                <img class="dot" src="assets/skills/github.png" />
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Tags : </b></h4>
                                <p> Angular, Bootstrap, Responsive, Web, GitHub</p>
                            </div>
                        </div>
                    </div>
                    <div class="row description">
                        <!-- Description of the project -->
                        <div class="col-sm-6">
                            <h4><b>Description :</b></h4>
                            <p>

                            </p>
                        </div>
                        <!-- Apports du projet -->
                        <div class="col-sm-6">
                            <h4><b>Bilan :</b></h4>
                            <p>

                            </p>
                        </div>
                        <br>
                        <!-- Project Title -->

                        <!-- Project date + duration -->
                        <p> Début du projet : Septembre 2021 <br> <br> Fin du projet : Décembre 2021<br> </p>
                        <br> <br>
                        <br>
                        <br> <img src="assets/POR_proj_smm.PNG"> <br>

                    </div>
                </mdb-card-body>
            </mdb-card>
        </div>
    </div>
</div>

<app-projects></app-projects>